import React, { useEffect, useRef, useState } from "react";
import InputContainer from "./InputContainer";
import { useSelector } from "react-redux";

const CustomerMobileAutocomplete = React.forwardRef((props, ref) => {
  const {
    label,
    name,
    placeholder,
    error,
    size,
    setValue,
    nameFieldName = "customerName",
    multiline,
    rows,
    onCustomChange,
    onFileChange,
    watch,
    mode,
    control,
    rules,
    hasOptions,
    options,
    defaultValue,
    ...otherProps
  } = props;

  const wrapperRef = useRef(null);
  const [count, setCount] = useState(0);
  const [display, setDisplay] = useState(false);
  const [numberMatch, setNumberMatch] = useState([]);
  
  const { customerData } = useSelector((state) => state.branch);

  const searchNumber = (text) => {
    if (!text || text.length === 0) {
      setDisplay(false);
      setNumberMatch([]);
      return;
    }
    const regex = new RegExp(`^${text}.*$`, "i");
    let matches = customerData?.filter((data) => {
      return data?.customerMobile?.match(regex);
    });
    
    if (matches && matches.length > 0) {
      setDisplay(true);
    } else {
      setDisplay(false);
    }
    setNumberMatch(matches || []);
  };

  const handleNumber = (e) => {
    setCount(e.target.value.length);
    searchNumber(e.target.value);
  };

  const SuggestionElement = (phone, customerNameStr) => {
    if (!phone) return null;
    let i;
    const number = [];
    for (i = 0; i < count; i++) {
      if (phone[i]) number.push(<strong key={`strong-${i}`} style={{ fontWeight: "bold" }}>{phone[i]}</strong>);
    }
    for (i = count; i < phone.length; i++) {
      if (phone[i]) number.push(<span key={`span-${i}`}>{phone[i]}</span>);
    }
    return (
      <div className="d-flex flex-column">
        <div>{number}</div>
        <div style={{ color: "#6c757d", fontSize: "0.85em" }}>{customerNameStr}</div>
      </div>
    );
  };

  const handleClick = (customer) => {
    if (setValue) {
      setValue(name, customer.customerMobile, { shouldValidate: true, shouldDirty: true });
      if (nameFieldName) {
        setValue(nameFieldName, customer.customerName, { shouldValidate: true, shouldDirty: true });
      }
    }
    setDisplay(false);
  };

  const handleClickOutside = (e) => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setDisplay(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <InputContainer {...props} label={label} error={error} size={size}>
      <div className="position-relative" ref={wrapperRef}>
        <input
          ref={ref}
          type="text"
          className="form-control"
          name={name}
          placeholder={placeholder}
          autoComplete="off"
          defaultValue={defaultValue}
          {...otherProps}
          onChange={(e) => {
            handleNumber(e);
            if (otherProps.onChange) {
              otherProps.onChange(e);
            }
          }}
        />
        {display && numberMatch.length > 0 && (
          <div
            className="position-absolute bg-white w-100 p-1 border"
            style={{ 
              zIndex: 1000, 
              maxHeight: "200px", 
              overflowY: "auto", 
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
              top: "100%",
              left: 0
            }}
          >
            {numberMatch.map((item, index) => {
              return (
                <div
                  key={index}
                  style={{
                    width: "100%",
                    fontSize: 14,
                    padding: "8px 10px",
                    cursor: "pointer",
                    borderBottom: index < numberMatch.length - 1 ? "1px solid #eee" : "none"
                  }}
                  className="d-flex justify-content-start suggestion"
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                  onClick={() => handleClick(item)}
                >
                  {SuggestionElement(item.customerMobile, item.customerName)}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </InputContainer>
  );
});

export default CustomerMobileAutocomplete;
